import styled, { createGlobalStyle } from 'styled-components'
import { Button, Card, Tabs } from 'antd'

export const ListDepartmentContent = styled.div`
  margin-top: 10px;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
`

export const ContactLayout = styled.section`
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  gap: 24px;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`

export const DepartmentNav = styled.nav`
  min-width: 0;

  @media (max-width: 767px) {
    overflow: hidden;
  }
`

export const DepartmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 78vh;
  overflow-y: auto;
  padding-right: 6px;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 9999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #cbd5e1;
  }

  @media (max-width: 767px) {
    flex-direction: row;
    overflow-x: auto;
    padding-bottom: 6px;
  }
`

export const DepartmentButton = styled(Button)`
  display: flex;
  align-items: center;
  min-height: 42px;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 400;
  padding: 0 16px;
  text-align: left;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: none;

  &:hover {
    border-color: #9cd4fc;
    background: #eff8ff;
    color: #0f172a;
    box-shadow: 0 2px 8px rgba(112, 174, 251, 0.16);

    span {
      color: #0f172a;
    }
  }

  &:focus {
    outline: none;
  }

  &.active {
    border-color: #9cd4fc;
    background: #eff8ff;
    color: #0f172a;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(112, 174, 251, 0.16);
    transform: none;

    span {
      color: #0f172a;
      font-weight: 600;
    }
  }

  span {
    display: block;
    width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.2s ease;
    font-weight: inherit;
  }

  @media (max-width: 767px) {
    flex: 0 0 auto;
    width: auto;
    max-width: 220px;
    border-radius: 8px;

    &:hover {
      transform: none;
    }
  }
`

export const ContactPanel = styled.main`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: calc(100vh - 180px);
  border-radius: 16px;
  background: #f6f6f6;
  border: 1px solid #e2e8f0;
  padding: 24px;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .ant-spin-nested-loading {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
  }

  .ant-spin-container {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
  }

  @media (max-width: 767px) {
    padding: 16px;
  }
`

export const PanelHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 1023px) {
    align-items: stretch;
    flex-direction: column;
  }
`

export const PanelTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .title-text {
    color: #0f172a;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 18px !important;
    font-weight: 400 !important;
    line-height: 26px !important;
    letter-spacing: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .count-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 6px;
    background: #eff8ff;
    color: #475569;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    white-space: nowrap;
    flex-shrink: 0;
  }
`

export const SearchActions = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 12px;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .ant-input-affix-wrapper {
    width: 250px;
    height: 40px;
    border-color: #e2e8f0;
    border-radius: 8px;
    padding: 0 14px;
    background: #ffffff;
    transition: all 0.2s ease;

    &:hover,
    &:focus,
    &.ant-input-affix-wrapper-focused {
      border-color: #9cd4fc;
      box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.18);
    }

    .ant-input {
      font-size: 14px !important;
    }
  }

	  .contact-search-icon {
	    color: #94a3b8;
	    cursor: pointer;
    font-size: 15px;
    transition: color 0.2s ease;

    &:hover {
      color: #70aefb;
    }
	  }

	  .excel-icon {
	    color: #107c41;
	  }

	  .ant-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #ffffff;
    color: #334155;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    font-weight: 600;
    font-size: 14px !important;
    padding: 0 16px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      border-color: #107c41;
      color: #107c41;
      box-shadow: 0 2px 8px rgba(16, 124, 65, 0.12);
    }

    &:disabled {
      opacity: 0.6;
    }
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;

    .ant-input-affix-wrapper {
      width: 100%;
    }

    .ant-btn {
      width: 100%;
      justify-content: center;
    }
  }
`

export const EmployeeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: minmax(236px, auto);
  gap: 20px 16px;
  align-content: start;
  min-height: 748px;

  .ant-empty {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    margin: 0 auto;
    padding: 32px 0;
    width: 100%;

    .ant-empty-image {
      height: 44px;
      margin: 0 0 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.75;
      filter: grayscale(1);

      svg {
        width: auto;
        height: 40px;
        opacity: 0.8;
      }
    }

    .ant-empty-description {
      margin: 0;
      padding: 0;
      color: #94a3b8 !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      text-align: center;
    }
  }

  @media (max-width: 1199px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    min-height: 748px;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    min-height: 0;
  }
`

export const EmployeeCard = styled(Card)`
  display: flex;
  min-width: 0;
  min-height: 236px;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  cursor: pointer;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  padding: 24px 16px 20px;
  text-align: center;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-width: 0;
    padding: 0;
    text-align: center;
  }

  &:hover,
  &:focus {
    border-color: #bae6fd;
    box-shadow: 0 12px 24px -4px rgba(112, 174, 251, 0.15);
    outline: none;
    transform: translateY(-4px);

    .employee-name {
      color: #0f172a;
    }
  }

  .card-avatar {
    background: #70aefb;
    color: #ffffff;
    font-size: 26px;
    font-weight: 600;
    border: 3px solid #ffffff;
    box-shadow: 0 4px 14px rgba(112, 174, 251, 0.25);
    transition: transform 0.25s ease;
  }

  &:hover .card-avatar {
    transform: scale(1.05);
  }
`

export const EmployeeName = styled.div`
  width: 100%;
  margin-top: 14px;
  color: #0f172a;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  white-space: nowrap;
  transition: color 0.2s ease;
`

export const EmployeeRole = styled.div`
  display: inline-block;
  max-width: 90%;
  margin-top: 6px;
  padding: 2px 10px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const EmployeeMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #f1f5f9;
  align-items: center;
  width: 100%;
`

export const EmployeeContactRow = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 100%;
  min-width: 0;
  color: #70aefb;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .anticon {
    flex: 0 0 auto;
    font-size: 14px !important;
  }
`

export const EmployeeContactText = styled.div`
  display: block;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 200px;
  color: #475569;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ContactDetailModalStyle = createGlobalStyle`
  .contact-detail-modal {
    font-family: "Inter", Noto Sans Display, sans-serif !important;
  }

  .contact-detail-modal .ant-modal {
    max-width: calc(100vw - 32px);
    font-family: "Inter", Noto Sans Display, sans-serif !important;
  }

  .contact-detail-modal .ant-modal-content {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px -8px rgba(15, 23, 42, 0.2);
    font-family: "Inter", Noto Sans Display, sans-serif !important;
  }

  .contact-detail-modal .ant-modal-header {
    border-bottom: 1px solid #f1f5f9;
    padding: 20px 28px;
    background: #ffffff;
  }

  .contact-detail-modal .ant-modal-title {
    color: #0f172a;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 18px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0;
  }

  .contact-detail-modal .ant-modal-close {
    top: 18px;
    right: 20px;
  }

  .contact-detail-modal .ant-modal-close-x {
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 8px;
    transition: background 0.2s ease;

    &:hover {
      background: #f1f5f9;
    }
  }

  .contact-detail-modal .ant-modal-body {
    background: #ffffff;
    padding: 28px 28px 32px;
  }

  @media (max-width: 767px) {
    .contact-detail-modal .ant-modal-header {
      padding: 16px 20px;
    }

    .contact-detail-modal .ant-modal-title {
      font-size: 18px;
    }

    .contact-detail-modal .ant-modal-body {
      padding: 20px 16px 24px;
    }
  }
`

export const UserDetailContent = styled.div`
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .profile-heading {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    text-align: center;
  }

	  .profile-heading .ant-avatar {
	    background: #70aefb;
    border: 4px solid #ffffff;
	    box-shadow: 0 8px 24px rgba(112, 174, 251, 0.25);
	  }

	  .profile-heading .avatar-initial {
	    font-size: 36px;
	    font-weight: 600;
	  }

  .profile-heading h1 {
    color: #0f172a;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 16px 0 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
    white-space: nowrap;
  }

  .detail-grid {
    .ant-col {
      display: flex;
    }
  }
`

export const UserDetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #f8fafc;
  border: 1px solid #eef2f6;
  border-radius: 12px;
  min-height: 58px;
  width: 100%;
  height: 100%;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }

  .detail-icon-wrapper {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #eff8ff;
    color: #70aefb;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
  }

  .detail-info {
    min-width: 0;
    flex: 1;
  }

  .detail-value {
    min-width: 0;
    color: #0f172a;
    font-size: 14px !important;
    font-weight: 500;
    line-height: 20px;
    overflow-wrap: anywhere;
  }

  .detail-value.empty {
    color: #94a3b8;
    font-style: italic;
    font-weight: 400;
  }

  .detail-label {
    display: block;
    color: #64748b;
    font-size: 13px !important;
    font-weight: 400;
    line-height: 18px;
    margin-top: 2px;
  }
`

export const TabsDepartmentWrapper = styled(Tabs)`
  .ant-tabs-nav {
    max-height: 85vh;
  }

  .ant-tabs-content {
    min-height: 85vh;
  }

  .ant-tabs-tabpane {
    padding-left: 10px !important;
  }

  .ant-tabs-tab-active {
    background-color: #fafafa;

    a {
      color: #1890ff !important;
    }

    .edit-icon {
      opacity: 1 !important;
      visibility: visible !important;
    }
  }

  .ant-tabs-tab:hover {
    transition: 0.3s;
    background-color: #fafafa;
  }

  .ant-tabs-tab {
    padding-right: 10px;

    .edit-icon {
      opacity: 0;
      visibility: hidden;
      transition: 0.3s;
    }

    &:hover {
      .edit-icon {
        opacity: 1;
        visibility: visible;
      }
    }

    a {
      display: inline-block !important;
      text-align: left;
    }

    .ant-tabs-tab-btn {
      display: flex;
      align-items: center;
    }
  }
`
